import React from 'react';
import { useLiveExactLimits } from '../../hooks/useLiveExactLimits';
import { dayShown, mergeLimits, minuteShown, Shown } from '../../components/ScenarioRun/RunDetail/exactLimitsModel';
import { countdown, number } from '../data/format';
import { useNow } from '../data/usePoll';

const tone = (s: Shown) => {
    if (s.simulated || s.remaining <= 0) return 'bad';
    if (s.limit && s.remaining / s.limit < 0.2) return 'warn';
    return '';
};

const Meter = ({ label, shown, now }: { label: string; shown: Shown; now: number }) => {
    const pct = shown.limit ? Math.max(0, Math.min(100, (shown.remaining / shown.limit) * 100)) : 0;
    const t = tone(shown);

    return (
        <div className="xlim" title={shown.simulated ? 'Daglimiet nagebootst door een scenario' : undefined}>
            <div className="xlim-top">
                <span className="mut">{label}</span>
                <b className={t}>
                    {number(shown.remaining)}
                    {shown.limit ? <span className="mut"> / {number(shown.limit)}</span> : null}
                </b>
            </div>
            <div className="meter">
                <b className={t === 'bad' ? 'b' : t === 'warn' ? 'w' : undefined} style={{ width: `${pct}%` }} />
            </div>
            <div className="xlim-reset mono mut">{shown.resetsAt ? countdown(shown.resetsAt, now) : '–'}</div>
        </div>
    );
};

/**
 * Exact's day and minute of the environment you are in, live from the limits hub, with how long until each starts
 * over. Nothing until the connector or the dashboard read the limits once.
 */
export const ExactLimitsHeader = ({ customer, environment }: { customer: string; environment: string }) => {
    const board = useLiveExactLimits(customer, environment);
    const now = useNow(1000);
    const view = mergeLimits(undefined, board);

    if (!view) return null;

    const day = dayShown(view, now);
    const minute = minuteShown(view, now);

    return (
        <div className="xlims" aria-label="Exact-limieten">
            {day && <Meter label="Exact dag" shown={day} now={now} />}
            <Meter label="Minuut" shown={minute} now={now} />
        </div>
    );
};
